const styles = theme => ({
  contentDiv: {
    margin: 'auto',
    width: '752px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
})

export default styles
